import { createAsyncThunk } from "@reduxjs/toolkit";
import { getEventByEventId } from "apis/EventServiceApi";
import { setEventDetails } from "./eventDetails.slice";


export const fetchEventDetails = createAsyncThunk(
  "eventDetails/fetchEventDetails",
  async (eventId: number, thunkAPI) => {
    try {
      const response = await getEventByEventId({ id: eventId });
      thunkAPI.dispatch(setEventDetails(response))
    } catch (error: any) {
       thunkAPI.rejectWithValue(error.message || "Error fetching event detail");
    }
  }
);
